import axios from "axios";
import {
    URLAPI,
    FIELD_TYPES_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_field_types: {
        data: [],
        status: 0,
        message: {},
    },
}

const GET_ALL_FIELD_TYPES = "GET_ALL_FIELD_TYPES";

export const field_types_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_FIELD_TYPES:
            return {
                ...state,
                _get_all_field_types: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}


export const get_all_field_types = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${FIELD_TYPES_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_FIELD_TYPES,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_FIELD_TYPES,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_FIELD_TYPES,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al obtener los registros",
                },
            });
        }
    }
}
